<template>
  <v-alert
    class="mb-4"
    type="warning"
    dense
    :icon="$vuetify.breakpoint.mdAndUp ? 'mdi-lock' : false"
    :prominent="$vuetify.breakpoint.mdAndUp"
  >
    <v-row align="center">
      <v-col class="grow">
        <span class="font-weight-medium">{{ $t('message.feature_not_available_in_current_plan') }}</span>&nbsp;<i18n
          v-if="!isVIP && planNames"
          path="message.feature_upgrade_to_plan"
          tag="span"
          class="mb-0 pt-2"
        >
          <span class="font-weight-bold">{{ planNames }}</span>
        </i18n>

        <p class="mb-0">
          {{ text }}
        </p>
        <p
          v-if="isVIP"
          class="mb-0 pt-2"
        >
          {{ $t('message.talk_to_sales_to_upgrade') }}
        </p>
      </v-col>
      <v-col
        v-if="!isVIP"
        class="shrink"
      >
        <v-btn @click="upgradePlanAction">
          <v-icon>
            mdi-lock-open-plus-outline
          </v-icon>
          <template v-if="$vuetify.breakpoint.mdAndUp">
            {{ $t('button.view_upgrade_options') }}
          </template>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router/composables';
import { computed, PropType } from 'vue';
import store from '@/store/store';
import { BillingInfoSubscriptionStatus } from '@/model/Account';
import { TranslateResult } from 'vue-i18n';
import { PaywallPlan, paywallPlanNames } from '@/services/billing-utils';

const router = useRouter();

const isVIP = computed(() => store.state.settings.account.subStatus === BillingInfoSubscriptionStatus.VIP);

const props = defineProps({
  text: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
  plans: { type: Array as PropType<PaywallPlan[]>, required: false, default: () => [] },
});

const planNames = computed(() => paywallPlanNames(props.plans));

const upgradePlanAction = () => {
  router.push('/settings/billing?upgrade=true');
};

</script>
